/**
 * Kørselskonfiguration. Alle værdier kommer fra environment variables med VITE_-præfiks
 * (se .env.example). Der må ikke stå hemmeligheder her - kun offentlige id'er og URL'er.
 */
export const config = {
  /** Basis-URL til API-et, f.eks. https://api.firma.dk. Tom streng = samme origin. */
  apiUrl: (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, ''),

  entra: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? '',
    /** Scope API-et kræver, typisk api://<client-id>/access_as_user. */
    apiScope: import.meta.env.VITE_ENTRA_API_SCOPE ?? '',
    redirectUri: import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin
  },

  appName: import.meta.env.VITE_APP_NAME ?? 'Projekt Overblik',

  /**
   * Adressen brugerne tilgår systemet på, f.eks. https://flow.tc-el.dk.
   * Bruges i QR-koderne på enhedsmærkaterne, som bliver printet og sat op fysisk -
   * de skal pege på den rigtige adresse, ikke på den maskine der lavede dem.
   * Tom = brug browserens egen adresse (fint ved udvikling).
   */
  publicUrl: (import.meta.env.VITE_PUBLIC_URL ?? '').replace(/\/$/, ''),

  /**
   * Kun udvikling: sendes som X-Dev-User når Entra ID endnu ikke er sat op.
   * Format: "email;Navn;Rolle". Kræver AUTH_DEV_BYPASS=true på API-siden.
   */
  devUser: import.meta.env.VITE_DEV_USER ?? ''
}

export const isEntraConfigured = Boolean(config.entra.clientId && config.entra.tenantId)
